import React from 'react';
import RangeCalView from "../RangeCalView/rangeCalView";

class ProgressiveOverlay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            areaName: "Goa",
            travelFrmDt: "16",
            travelToDt: "17 Apr",
            travlrCount: "1",
            travlrClass: "1"
        }
    }

    render() {

        // activeTab and activeTb are different

        const { closeOverlay, activeTab, changeActiveTab, page, isBusCard, moveToFunnelParams } = this.props;


        return (
            <div className={`prgsvOverlay ${activeTab == 1 ? "selDate" : ""}`}>
                <div style={{padding: "10px", display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '14px', alignItems: 'center'}} className="prgsvOverlay__hdr">
                    <span style={{fontSize: '16px', fontWeight: 'bold'}}>Pick a journey date</span>
                    <span 
                        style={{width: "14px", height: "14px"}} 
                        className="sp__srchFrmSprt--cross sp__srchFrmSprt iconRipple" 
                        onClick={() => {closeOverlay()}}>       
                    </span>
                </div>
                <div className="widgetWrap">
                <RangeCalView
                lobName={"hotel"}
                setActiveTab={undefined} 
                activeTb={1} 
                changeActiveTab={changeActiveTab} 
                numberOfMonths={12}
                dayAdditionalData={new Array(31).fill(0)}
                // dayAdditionalData={new Array(31).fill(0).map(()=>randomDayData())}
                moveToFunnelParams={moveToFunnelParams}
                page={page}
                isBusCard={isBusCard}
            />
                </div>
            </div>
        );
    }
}

export default ProgressiveOverlay;
